//the connect utility helps us map the state to react component's props
import {
	connect
} from 'react-redux';

import assign from "lodash/assign";

import {
	hashHistory
} from 'react-router'

import getSavedApp from 'utils/load-application';

import PersonalInformation from "./PersonalInformation.jsx";

import cinemas from 'utils/cinemas';

const mapStateToProps = (state) => {
	let form = state.form['employment-application'];
	let errors = form ? assign({}, form.syncErrors) : {};
	for (var field in errors) {
		if (!form.fields || !form.fields[field] || !form.fields[field].touched) {
			delete errors[field];
		}
	}

	return {
		config: state.config,
		errors: errors,
		initialValues: getSavedApp(),
		cinemas
	};
}

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		onSubmit: () => hashHistory.push("/employment-desired")
	};
}

const PersonalInformationContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(PersonalInformation);


export default PersonalInformationContainer;